import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
	},
	title: {
		fontFamily: tokens.fontFamilyBase,
		fontSize: tokens.fontSizeBase300,
		fontWeight: tokens.fontWeightSemibold,
		lineHeight: tokens.lineHeightBase300,
	},
	ownerLabel: {
		fontFamily: tokens.fontFamilyBase,
		fontSize: tokens.fontSizeBase300,
		fontWeight: tokens.fontWeightRegular,
		lineHeight: tokens.lineHeightBase300,
	},
	ownerValue: {
		marginLeft: '8px',
		fontFamily: tokens.fontFamilyBase,
		fontSize: tokens.fontSizeBase300,
		fontWeight: tokens.fontWeightRegular,
		lineHeight: tokens.lineHeightBase300,
	},
	actorTitle: {
		fontFamily: tokens.fontFamilyBase,
		fontSize: tokens.fontSizeBase300,
		fontWeight: tokens.fontWeightRegular,
		lineHeight: tokens.lineHeightBase300,
	},
	actorOptionsRow: {
		display: 'flex',
		flexDirection: 'row',
		gap: '0px',
		alignItems: 'center',
	},
	ownerSkeleton: {
		width: '100%',
		gap: '8px',
		marginTop: '8px',
	},
	ownerSkeletonItem: {
		height: '24px',
		width: '180px',
		backgroundColor: tokens.colorNeutralBackground5,
		':after': {
			backgroundImage: `linear-gradient(to right, ${tokens.colorNeutralBackground5} 0%, ${tokens.colorNeutralBackground2} 50%, ${tokens.colorNeutralBackground5} 100%)`
		}
	},
	ownerSkeletonSP: {
		height: '24px',
		width: '240px',
		backgroundColor: tokens.colorNeutralBackground5,
		':after': {
			backgroundImage: `linear-gradient(to right, ${tokens.colorNeutralBackground5} 0%, ${tokens.colorNeutralBackground2} 50%, ${tokens.colorNeutralBackground5} 100%)`
		}
	}
});
